/* Aroha Artisan custom-coaster native form. */
(()=>{
/** Pure business helpers. Prices are explanatory estimates; Shopify owns checkout totals. */
const APPROVED_PRICING = Object.freeze({id:'normal',currency:'NZD',single:2250,fourSaving:1000,sixSaving:2000,bulkThreshold:7,bulkEach:1875,totals:Object.freeze({4:8000,5:10250,6:11500})});
const LABOUR_SALE_PRICING = Object.freeze({id:'labour-2026',currency:'NZD',single:1688,bulkThreshold:7,bulkEach:1406,totals:Object.freeze({4:6000,5:7688,6:8625})});
const LABOUR_SALE_WINDOW = Object.freeze({startsAt:'2026-10-19T11:00:00Z',endsAt:'2026-10-28T11:00:00Z',startsMs:Date.parse('2026-10-19T11:00:00Z'),endsMs:Date.parse('2026-10-28T11:00:00Z')});
function quantity(value, max=999) {
  const n=Number(value);
  if (!Number.isInteger(n)||n<1||n>max) throw new Error(`Choose a whole quantity from 1 to ${max}.`);
  return n;
}
function estimatedTotal(count,pricing=APPROVED_PRICING) {
  if (!Number.isInteger(count)||count<0) throw new Error('Invalid coaster quantity.');
  if (count>=pricing.bulkThreshold) return count*pricing.bulkEach;
  return pricing.totals[count]??count*pricing.single;
}
function priceLabel(cents){return money(cents).replace(/\.00$/,'');}
function pricingPreviewMode(preview,href){
 if(preview!==true)return null;
 try{const mode=new URL(href).searchParams.get('aa_price_preview');return ['before','sale','after'].includes(mode)?mode:null;}catch{return null;}
}
function pricingContextAt(nowMs,previewMode=null){
 const simulated=['before','sale','after'].includes(previewMode);
 const effective=simulated?{before:LABOUR_SALE_WINDOW.startsMs-1,sale:LABOUR_SALE_WINDOW.startsMs+3600000,after:LABOUR_SALE_WINDOW.endsMs}[previewMode]:nowMs;
 const phase=Number.isFinite(effective)&&effective>=LABOUR_SALE_WINDOW.startsMs&&effective<LABOUR_SALE_WINDOW.endsMs?'sale':Number.isFinite(effective)&&effective<LABOUR_SALE_WINDOW.startsMs?'upcoming':'normal';
 const pricing=phase==='sale'?LABOUR_SALE_PRICING:APPROVED_PRICING;
 let notice=phase==='sale'?'Labour Weekend savings · 20–28 October 2026. Quantity savings are included in the prices shown.':phase==='upcoming'?'Labour Weekend offer starts 20 October 2026. Current prices are shown below.':'';
 if(simulated)notice='Private price preview: '+({before:'before the offer',sale:'Labour Weekend sale, 20–28 October 2026',after:'after the offer'})[previewMode]+'. Simulation only; checkout follows the actual date.';
 return {phase,pricing,simulated,previewMode:simulated?previewMode:null,notice};
}
function nextPricingBoundaryAt(nowMs){return nowMs<LABOUR_SALE_WINDOW.startsMs?LABOUR_SALE_WINDOW.startsMs:nowMs<LABOUR_SALE_WINDOW.endsMs?LABOUR_SALE_WINDOW.endsMs:null;}
function pricingBetweenText(pricing){return '5 coasters: '+priceLabel(estimatedTotal(5,pricing))+' · 7 coasters: '+priceLabel(estimatedTotal(7,pricing));}
function money(cents,currency='NZD') { return new Intl.NumberFormat('en-NZ',{style:'currency',currency}).format(cents/100); }
function normalized(value) {return String(value??'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}
function matches(design,query,category='All designs') {
  return (category==='All designs'||design.category===category) && normalized([design.name,...design.internalNames].join(' ')).includes(normalized(query).trim());
}
/** One default gallery exposes the full active range without changing use/commerce eligibility. */
function visibleDesigns(catalogue,query='',filter='All designs') {
  // Two of each use per group exposes both ranges from the first desktop row,
  // while retaining simple same-use pairs on a two-column mobile gallery.
  const coaster=catalogue.filter(d=>d.use==='functional'),display=catalogue.filter(d=>d.use==='display'),ordered=[];
  for(let i=0;i<Math.max(coaster.length,display.length);i+=2)ordered.push(...coaster.slice(i,i+2),...display.slice(i,i+2));
  ordered.push(...catalogue.filter(d=>!['functional','display'].includes(d.use)));
  return ordered.filter(d=>{
    const useMatches=filter==='Coaster designs'?d.use==='functional':filter==='Display only'?d.use==='display':true;
    return useMatches&&matches(d,query,['Coaster designs','Display only'].includes(filter)?'All designs':filter);
  });
}
/** Intended use never determines whether an active design can be purchased. */
function isPurchasableDesign(design) {return design?.purchaseEligible===true&&design?.purchasable===true&&Boolean(design?.variantId);}
function hydrateCatalogue(catalogue,product) {
  const variants=new Map((product?.variants??[]).map(v=>[String(v.id),v]));
  return catalogue.map(d=>{
    const v=variants.get(d.variantId);
    return {...d,available:!!v?.available,currentPriceCents:v?Number(v.price):null,verified:!!v};
  });
}
function validateFile(file,maxBytes=10*1024*1024) {
  if(!file) return null;
  const allowed={jpg:['image/jpeg'],jpeg:['image/jpeg'],png:['image/png'],webp:['image/webp'],pdf:['application/pdf']};
  const extension=file.name.toLowerCase().split('.').pop();
  if(!allowed[extension] || (file.type && !allowed[extension].includes(file.type))) return 'Use a JPG, PNG, WEBP or PDF file.';
  if(!file.size) return 'That file is empty. Please choose another file.';
  if(file.size>maxBytes) return 'Choose a file smaller than 10 MB.';
  return null;
}
function lineProperties(line,selectionId) {
  const p={'Design':line.design.name,'Intended use':line.design.use==='display'?'Display only — no drinks or food':'Coaster for drinks','_aa_selection_id':selectionId,'_aa_line_id':line.id};
  if(line.text) p['Engraving text']=line.text;
  if(line.instructions) p['Personalisation instructions']=line.instructions;
  if(line.personalised) p['Personalisation']='Standard personalisation requested';
  return p;
}
function reconcileLine(cart,line,selectionId) {
  const found=(cart?.items??[]).filter(i=>String(i.variant_id??i.id)===line.design.variantId && i.properties?._aa_selection_id===selectionId && i.properties?._aa_line_id===line.id);
  return {quantity:found.reduce((sum,i)=>sum+i.quantity,0), keys:found.map(i=>i.key)};
}
function publicProperties(properties) {return Object.entries(properties??{}).filter(([k,v])=>!k.startsWith('_')&&v);}
/** This launch is explicitly NZD-only; never infer a currency from a numeric price. */
function isNZDContext(renderedCurrency,runtimeCurrency,cartCurrency,requireCart=false) {
  if(renderedCurrency!=='NZD')return false;
  if(runtimeCurrency&&runtimeCurrency!=='NZD')return false;
  if(requireCart&&cartCurrency!=='NZD')return false;
  if(cartCurrency&&cartCurrency!=='NZD')return false;
  return true;
}
function preservePreviewLink(target,currentHref,themeContext) {
  const current=new URL(currentHref),next=new URL(target,current);
  if(current.origin!==next.origin)return next.href;
  // Shopify can consume the entry parameter into its preview cookie before JS runs.
  // Reconstruct same-origin crosslinks from the verified unpublished theme context.
  const queryTheme=current.searchParams.get('preview_theme_id');
  const renderedTheme=themeContext?.role==='unpublished'?String(themeContext.id??''):'';
  const valid=value=>typeof value==='string'&&/^[1-9]\d*$/.test(value);
  const theme=valid(queryTheme)?queryTheme:valid(renderedTheme)?renderedTheme:null;
  if(theme)next.searchParams.set('preview_theme_id',theme);
  const pricingMode=pricingPreviewMode(true,current.href);if(pricingMode)next.searchParams.set('aa_price_preview',pricingMode);
  return next.href;
}

function coasterCountLabel(count) {return `${count} ${count===1?'coaster':'coasters'}`;}
function trayFitsSection(sectionTop,sectionBottom,viewportHeight) {
  return sectionTop<viewportHeight && sectionBottom>viewportHeight+16;
}

/** Tab-local, bounded draft. Never stores names, text, files, prices or cart data. */
const SELECTION_DRAFT_VERSION=1;
const SELECTION_DRAFT_TTL_MS=2*60*60*1000;
function selectionDraftAllowlist(catalogue,preview=false) {
 return new Set(catalogue.filter(d=>isPurchasableDesign(d)&&(preview||d.verified===true)).map(d=>d.variantId));
}
function selectionDraftKey(preview,themeId) {
 const id=/^[1-9]\d*$/.test(String(themeId??''))?String(themeId):'local';
 return `aa:slate-selection:v1:${preview?'preview:'+id:'live'}`;
}
function decodeSelectionDraft(raw,allowed,now=Date.now()) {
 if(typeof raw!=='string'||raw.length>16384)return [];
 try{
  const draft=JSON.parse(raw);
  if(!draft||Array.isArray(draft)||Object.keys(draft).some(k=>!['version','expiresAt','items'].includes(k))||draft.version!==SELECTION_DRAFT_VERSION||!Number.isSafeInteger(draft.expiresAt)||draft.expiresAt<=now||draft.expiresAt>now+SELECTION_DRAFT_TTL_MS||!Array.isArray(draft.items)||draft.items.length>100)return [];
  const quantities=new Map();
  for(const item of draft.items){
   if(!item||Array.isArray(item)||Object.keys(item).some(k=>!['variantId','quantity'].includes(k))||typeof item.variantId!=='string'||!allowed.has(item.variantId)||!Number.isInteger(item.quantity)||item.quantity<1||item.quantity>999)continue;
   const n=(quantities.get(item.variantId)||0)+item.quantity;if(n>999)return [];
   quantities.set(item.variantId,n);
  }
  return [...quantities].map(([variantId,quantity])=>({variantId,quantity}));
 }catch{return [];}
}
function encodeSelectionDraft(items,allowed,now=Date.now()) {
 // Construct a strict whitelist, regardless of extra fields on caller objects.
 const clean=items.map(item=>({variantId:item.variantId,quantity:item.quantity}));
 const raw=JSON.stringify({version:SELECTION_DRAFT_VERSION,expiresAt:now+SELECTION_DRAFT_TTL_MS,items:clean});
 const normalized=decodeSelectionDraft(raw,allowed,now);
 if(clean.length&&(!normalized.length||clean.some(item=>!allowed.has(item.variantId)||!Number.isInteger(item.quantity)||item.quantity<1||item.quantity>999)))throw new Error('Invalid selection draft.');
 return JSON.stringify({version:SELECTION_DRAFT_VERSION,expiresAt:now+SELECTION_DRAFT_TTL_MS,items:normalized});
}
function readSelectionDraft(getStorage,key,allowed,now=Date.now()) {
 try{return {ok:true,items:decodeSelectionDraft(getStorage().getItem(key),allowed,now)};}catch{return {ok:false,items:[]};}
}
function writeSelectionDraft(getStorage,key,items,allowed,now=Date.now()) {
 try{
  const storage=getStorage();
  if(!items.length){storage.removeItem(key);return storage.getItem(key)===null;}
  const raw=encodeSelectionDraft(items,allowed,now);storage.setItem(key,raw);return storage.getItem(key)===raw;
 }catch{return false;}
}

/** Temporary merchant QA is confined to the exact unpublished theme, never a verification claim. */
function isPrivateQATransport(config,theme){
 return config?.qaTransport===true&&String(theme?.id)==='152532975793'&&theme?.role==='unpublished';
}

function isCustomSlateVariant(id){return String(id??'')==='48054729867441';}

/** Shared, server-anchored price display. Never changes cart data or the machine clock. */
function mountScheduledPricing(root,config,env={window,document,performance}){
 const win=env.window,doc=env.document,perf=env.performance;
 const previewMode=pricingPreviewMode(config.preview===true&&config.qaTransport!==true&&win.Shopify?.theme?.role==='unpublished',win.location.href);
 let baseMs=Number.isFinite(config.serverNowUnix)&&config.serverNowUnix>0?config.serverNowUnix*1000:NaN;
 let baseMono=perf.now(),timer=null,syncing=false,disposed=false;
 const now=()=>baseMs+Math.max(0,perf.now()-baseMono);
 const context=()=>pricingContextAt(now(),previewMode);
 const canShow=()=>config.preview===true||isNZDContext(config.currency,win.Shopify?.currency?.active);
 function refresh(){
  if(disposed)return;
  const refreshMs=now(),state=pricingContextAt(refreshMs,previewMode),show=canShow();
  root.dataset.aaPricingPhase=state.phase;root.dataset.aaPricingSimulated=String(state.simulated);
  root.querySelectorAll('[data-aa-price-group]').forEach(n=>n.hidden=!show);
  root.querySelectorAll('[data-aa-pricing-schedule]').forEach(n=>{n.textContent=state.notice;n.hidden=!show||!state.notice;});
  root.querySelectorAll('[data-aa-price-total]').forEach(n=>{
   const count=Number(n.dataset.aaPriceTotal),valid=Number.isInteger(count)&&count>=0&&count<=999*38;
   n.hidden=!show||!valid;
   if(valid)n.textContent=(n.dataset.aaPricePrefix||'')+priceLabel(estimatedTotal(count,state.pricing))+(n.dataset.aaPriceSuffix||'');
  });
  root.querySelectorAll('[data-aa-price-bulk]').forEach(n=>{n.hidden=!show;n.textContent=priceLabel(state.pricing.bulkEach)+' each';});
  root.querySelectorAll('[data-aa-price-between]').forEach(n=>{n.hidden=!show;n.textContent=pricingBetweenText(state.pricing);});
  if(timer!==null)win.clearTimeout(timer);
  const boundary=previewMode?null:nextPricingBoundaryAt(refreshMs);
  const delay=Number.isFinite(boundary)?Math.max(1,Math.min(60000,boundary-now())):60000;
  timer=win.setTimeout(refresh,delay);
 }
 async function syncServerClock(){
  if(disposed||previewMode||syncing||!win.fetch)return;
  syncing=true;
  try{
   // Same-origin HEAD only. No cart, file or personalisation data is requested or sent.
   const response=await win.fetch(win.location.href,{method:'HEAD',cache:'no-store',credentials:'same-origin'});
   const serverMs=Date.parse(response.headers.get('date'));
   if(response.ok&&Number.isFinite(serverMs)){baseMs=serverMs;baseMono=perf.now();refresh();}
  }catch{/* Retain the rendered server-time anchor; Shopify confirms final cart totals. */}
  finally{syncing=false;}
 }
 const resume=()=>{refresh();void syncServerClock();};
 const visible=()=>{if(doc.visibilityState==='visible')resume();};
 win.addEventListener('pageshow',resume);win.addEventListener('focus',resume);doc.addEventListener('visibilitychange',visible);
 refresh();
 return {context,refresh,dispose:()=>{disposed=true;if(timer!==null)win.clearTimeout(timer);win.removeEventListener('pageshow',resume);win.removeEventListener('focus',resume);doc.removeEventListener('visibilitychange',visible);}};
}

/* Native multipart product form; private page preview is inert and never posts. */
(() => {
 const root=document.querySelector('[data-aa-custom-coaster]');if(!root)return;
 const config=JSON.parse(root.querySelector('[data-aa-custom-config]').textContent);
 const qaTransport=isPrivateQATransport(config,window.Shopify?.theme);
 const inertPreview=config.preview&&!qaTransport;
 const form=root.querySelector('form');if(!form)return;
 const text=form.querySelector('[name="properties[Engraving text]"]'),file=form.querySelector('input[type=file]'),feedback=root.querySelector('[data-aa-custom-feedback]'),button=form.querySelector('[type=submit]');
 const preview=root.querySelector('[data-aa-file-preview]');let objectUrl=null,checking=false;
 const currencyOK=()=>isNZDContext(config.currency,window.Shopify?.currency?.active);
 const gates=()=>isCustomSlateVariant(config.variantId)&&config.available&&config.priceCents===2250&&currencyOK()&&(qaTransport||(config.enabled&&config.pricingVerified&&config.packagingApproved&&config.fileUploadVerified));
 const pricingController=mountScheduledPricing(root,config);
 const quantityInput=form.querySelector('[name=quantity]'),quantityEstimate=form.querySelector('[data-aa-custom-estimate]');
 const refreshQuantityEstimate=()=>{try{quantityEstimate.dataset.aaPriceTotal=quantity(quantityInput.value);}catch{quantityEstimate.dataset.aaPriceTotal='invalid';}pricingController.refresh();};
 quantityInput.addEventListener('input',refreshQuantityEstimate);quantityInput.addEventListener('change',refreshQuantityEstimate);refreshQuantityEstimate();
 const readyLink=root.querySelector('[data-aa-ready-link]');if(readyLink&&(config.preview||qaTransport)){readyLink.href=preservePreviewLink(config.readyUrl||readyLink.href,window.location.href,window.Shopify?.theme);}
 button.disabled=inertPreview||!gates();
 if(inertPreview)feedback.textContent='Private preview. Submission is disabled; your file stays in this tab.';
 else if(qaTransport)feedback.textContent='Private checkout test. Submit only the approved synthetic QA artwork.';
 else if(!currencyOK())feedback.textContent='This custom-coaster form currently supports NZD only. Your currency has not been changed. Choose NZD using the store’s currency selector if you want to order through this form.';
 else if(!config.available)feedback.textContent='Personalised slate coasters are currently unavailable. Please contact us before ordering.';
 // In a non-NZD live context, hide the fixed NZD offer instead of relabeling presentment prices.
 if(!config.preview&&!currencyOK())root.querySelectorAll('.aa-price-strip,.aa-price-between,.aa-price-note,.aa-shipping-offer,.aa-shipping-help,.aa-pricing-schedule,.aa-custom-estimate').forEach(n=>n.hidden=true);
 form.querySelector('[name="id"]').value=inertPreview?'':config.variantId||'';
 form.querySelector('[name="properties[_aa_line_id]"]').value=globalThis.crypto?.randomUUID?.()||`${Date.now()}-${Math.random().toString(36).slice(2)}`;
 file.addEventListener('change',()=>{
  preview.replaceChildren();if(objectUrl)URL.revokeObjectURL(objectUrl);objectUrl=null;const f=file.files[0];feedback.textContent=validateFile(f)||(inertPreview?'Private preview. Your file has not been uploaded.':'Your file is selected and has not been uploaded yet.');
  if(f&&!validateFile(f)){const label=document.createElement('p');label.textContent=f.name;preview.append(label);if(f.type.startsWith('image/')){const image=document.createElement('img');objectUrl=URL.createObjectURL(f);image.src=objectUrl;image.alt='Your selected artwork file';preview.append(image);}}
 });
 form.addEventListener('submit',async event=>{
  event.preventDefault();if(checking)return;
  if(inertPreview||!gates()){feedback.textContent=inertPreview?'Private preview only. No data has been sent.':'Ordering is unavailable in this currency or configuration. Your currency has not been changed.';return;}
  const error=validateFile(file.files[0]);
  if(error||(!text.value.trim()&&!file.files[0])){feedback.textContent=error||'Add the exact engraving text or upload your artwork file.';return;}
  if(!form.reportValidity())return;
  checking=true;button.disabled=true;button.textContent='Checking your cart…';
  try{
   const base=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
   const response=await fetch(base+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
   if(!response.ok)throw new Error('Could not confirm your cart currency. Nothing has been sent.');
   const cart=await response.json();
   if(!isNZDContext(config.currency,window.Shopify?.currency?.active,cart.currency,true))throw new Error('This form requires an NZD cart. Your file has not been sent and your currency has not been changed.');
   if(!gates())throw new Error('Ordering settings changed. Please reload before continuing.');
   button.textContent='Adding to cart…';
   HTMLFormElement.prototype.submit.call(form);
  }catch(error){feedback.textContent=error.message;checking=false;button.disabled=!gates();button.textContent='Add personalised coasters to cart';}
 });
 window.addEventListener('pageshow',event=>{if(event.persisted){refreshQuantityEstimate();checking=false;button.disabled=inertPreview||!gates();button.textContent='Add personalised coasters to cart';}});
})();

})();